import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";

const StyledTab = styled(Tab)({
  textTransform: "capitalize",
  display: "flex",
  justifyContent: "start",
  flex: 1,
  "&:focus-visible": {
    textDecoration: "none",
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  "&.MuiTab-labelIcon": {
    minHeight: "12px",
    paddingTop: 1,
  },
});

export default StyledTab;
